import { z } from 'zod';
import { IdSchema } from './common.js';
import { MoneySchema } from './money.js';
/**
 * Analitika — QAROR uchun, chiroyli grafik uchun emas.
 *
 * Uchta savolga javob beradi:
 *   1. Qayerda yangi do'kon ochish kerak (hudud)
 *   2. Nimani sotib olish kerak (natijasiz qidiruvlar)
 *   3. Qaysi mashinalarga tovar kerak (garaj)
 *
 * Har bir raqam shu savollardan biriga xizmat qiladi; qolgani
 * qo'shilmaydi.
 */
/** Hisobot oralig'i — kunlarda. */
export const AnalyticsPeriodSchema = z
    .object({ days: z.coerce.number().int().min(1).max(365).default(30) })
    .strict();
/**
 * Hudud kesimi.
 *
 * SIGNAL: buyurtma ko'p, lekin do'kon yo'q — yangi nuqta ochish
 * uchun asos (docs/02-MAHSULOT.md).
 */
export const RegionStatSchema = z.object({
    regionId: IdSchema,
    regionNameUz: z.string(),
    regionNameRu: z.string().nullable(),
    orders: z.number().int().nonnegative(),
    revenue: MoneySchema,
    /** Shu hududda faol do'kon bormi. */
    hasShop: z.boolean(),
});
/**
 * Natijasiz qidiruvlar.
 *
 * Bu — mijozlar sizdan sotib olmoqchi bo'lgan, lekin topa olmagan
 * tovarlar ro'yxati. Assortiment rejasi shundan chiqadi.
 */
export const EmptySearchStatSchema = z.object({
    queryNorm: z.string(),
    /** Necha marta qidirilgan. */
    count: z.number().int().positive(),
    /** Oxirgi marta qachon — eski so'rov endi ahamiyatsiz bo'lishi mumkin. */
    lastAt: z.string(),
});
/** Garajdagi mashinalar — qaysi modelga tovar kerakligi. */
export const GarageStatSchema = z.object({
    makeName: z.string(),
    modelName: z.string(),
    count: z.number().int().positive(),
});
export const AnalyticsResponseSchema = z.object({
    days: z.number().int().positive(),
    regions: z.array(RegionStatSchema),
    emptySearches: z.array(EmptySearchStatSchema),
    garage: z.array(GarageStatSchema),
    /** Umumiy: davr ichidagi buyurtma soni va tushum. */
    totalOrders: z.number().int().nonnegative(),
    totalRevenue: MoneySchema,
});
/* ========================== boshqaruv paneli ========================== */
/**
 * E'tibor talab qiladigan holat.
 *
 * `count` NOL bo'lsa qator KO'RSATILMAYDI — "0 ta muammo" degan
 * qator ekranni to'ldiradi va haqiqiy signalni ko'mib yuboradi.
 * Shuning uchun server nolni ham qaytaradi va yashirish qarorini
 * klient qabul qiladi (u tartibni ham biladi).
 */
export const AttentionKindSchema = z.enum([
    /// Tasdiqlanmagan yangi buyurtma — operator qo'ng'iroq qilishi kerak.
    'NEW_ORDERS',
    /// Natijasiz qidiruvlar — assortiment yoki teg muammosi.
    'EMPTY_SEARCHES',
    /// Biror do'konda tugagan tovar.
    'OUT_OF_STOCK',
    /// Tasdiqlanmagan to'lov — pul olindi deb yozilgan, lekin tekshirilmagan.
    'PENDING_PAYMENTS',
]);
export const AttentionItemSchema = z.object({
    kind: AttentionKindSchema,
    count: z.number().int().nonnegative(),
});
export const TopProductSchema = z.object({
    id: IdSchema,
    nameUz: z.string(),
    nameRu: z.string().nullable(),
    categoryIconKey: z.string().nullable(),
    /// Sotilgan DONA soni — pul emas: "ko'p sotilgan" savol miqdor haqida.
    soldCount: z.number().int().nonnegative(),
});
/**
 * Boshqaruv paneli.
 *
 * TANNARX va FOYDA javobda FAQAT `report.finance` ruxsati bo'lganda
 * bo'ladi. Nol qilib qaytarish YARAMAYDI: nol "foyda yo'q" degan
 * yolg'on ma'no berardi. Yo'qlik esa "sizga ko'rsatilmaydi" degani
 * va klient buni aniq shunday chizadi.
 */
export const DashboardResponseSchema = z.object({
    orders: z.number().int().nonnegative(),
    newOrders: z.number().int().nonnegative(),
    revenue: MoneySchema,
    /// `report.finance` yo'q bo'lsa — YO'Q (nol emas).
    grossProfit: MoneySchema.optional(),
    activeProducts: z.number().int().nonnegative(),
    draftProducts: z.number().int().nonnegative(),
    attention: z.array(AttentionItemSchema),
    topProducts: z.array(TopProductSchema),
});
//# sourceMappingURL=analytics.js.map